import styled from 'styled-components';
import { PrimaryTitleGray } from '../../../app/theme/tokens/colors';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`;

const Title = styled.h3`
  color: ${PrimaryTitleGray};
  margin: 0;
`;

const Subtitle = styled.span`
  color: #666;
  font-size: 14px;
`;

export const OrderFlowPageHeader = ({ title, subtitle }) => (
  <Header>
    <div>
      <Title>{title}</Title>
      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
    </div>
  </Header>
);
